import { Paper, TextField, Button } from "@mui/material";
import { styled } from "styled-components";

export const FormContainer = styled(Paper)`
  padding: 1rem;
  boxshadow: ${({ theme }) => theme.shadows.boxShadow};
  borderradius: 6px;
  marginbottom: 1rem;
  width: 600px;
  filter: ${({ theme }) => theme.shadows.filter};

  .MuiFormControl-root {
    label {
      position: absolute;
      top: calc((100% - 1.25rem) / 2);
      bottom: 0;
      left: 1rem;
      transform: none;
    }

    box-shadow: inset 1px 1px 2.2px hsl(0deg 0% 0% / 0.3);
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const FormTitle = styled("h5")(({ theme }) => ({
  marginBottom: "1rem",
  fontWeight: 500,
  color: theme.colors.textColor,
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    boxShadow: theme.shadows.boxShadowInset,
    "&:hover": {
      boxShadow: theme.shadows.boxShadowInset,
    },
    "&.Mui-focused": {
      boxShadow: theme.shadows.boxShadowInset,
    },
  },
}));

export const StyledMultilineText = styled(StyledTextField)({
  "& .MuiOutlinedInput-root": {
    height: "auto",
  },
});

export const ActionButton = styled(Button)(({ theme, color = "primary" }) => ({
  padding: "0.5rem",
  boxShadow: theme.shadows.boxShadow,
  fontWeight: 500,
  textTransform: "none",
}));
